import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { of, Subject, Subscription } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { ExternalSearchLink, ExternalSearchResult } from 'src/app/models/external-search.model';
import { ExternalSearchService } from 'src/app/services/external-search.service';

const MIN_QUERY_LENGTH = 3;

// Offres trouvées chez les marchands partenaires (tous les réseaux, côté API) quand la recherche ne trouve aucun deal
// PromoDeep : affiché par le dashboard sous « aucun contenu ». Les cartes ouvrent directement le lien affilié.
@Component({
    selector: 'app-external-search-results',
    templateUrl: './external-search-results.component.html',
    styleUrls: ['./external-search-results.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExternalSearchResultsComponent implements OnChanges, OnDestroy {

  @Input() query = '';

  results: ExternalSearchResult[] = [];
  links: ExternalSearchLink[] = [];
  loading = false;
  searchedQuery = '';
  // Photos du marchand qui ne se chargent pas : icône à la place (pas de copie en base, ce ne sont pas des deals)
  brokenPictures = new Set<string>();

  private readonly queries = new Subject<string>();
  private readonly subscription: Subscription;

  constructor(private externalSearchService: ExternalSearchService) {
    // La recherche du header est relancée à chaque frappe : seule la dernière est envoyée
    this.subscription = this.queries.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.loading = true),
      switchMap(query => this.externalSearchService.search(query).pipe(catchError(() => of(null)))),
    ).subscribe(response => {
      this.loading = false;
      this.results = response?.results || [];
      this.links = response?.links || [];
      this.searchedQuery = response?.query || '';
    });
  }

  ngOnChanges(): void {
    const query = (this.query || '').trim();
    if (query.length < MIN_QUERY_LENGTH) {
      this.results = [];
      this.links = [];
      return;
    }
    this.queries.next(query);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
